// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ff9f042a","186":"2d29b2ca","272":"f5113f20","372":"f2129548","377":"feedf835","738":"e3d8a629","841":"d3d50b1b","851":"f8aa8e94","856":"ab53f190"}[chunkId] + ".chunk.js";
};